import ApiConfig from "../../../config/api-config";
import { $apiClient } from "../../../utils/apiClient";

export function postResetPassword(payload) {

  return $apiClient.post(`${ApiConfig.RESETPASSWORD}`,payload);
}
